import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import useDropdownItems from "../../hooks/useDropdownItems";
import "./DropdownOptionsUsers.scss";

export type DropdownOptionsEventProps = {
  itemId: number;
  onDelete: (id: number) => void;
  onModify: (id: number) => void;
};

const DropdownOptionsUsers = (props: DropdownOptionsEventProps) => {
  const items = useDropdownItems(props);

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <Button
        type="link"
        icon={<MoreOutlined className="icon-more" />}
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  );
};

export default DropdownOptionsUsers;
